import {
  useActions,
  useEffect,
  useMutations,
  useQueryParams,
  useVertical,
} from '.'
import usePersistedUserData from './usePersistedUserData'

const useConvertToRep = () => {
  const { account } = usePersistedUserData()
  const { graphqlVerticalID } = useVertical()
  const actions = useActions()
  const mutations = useMutations()
  const queryParams = useQueryParams()

  const accType = account?.type
  const username = account?.username

  useEffect(() => {
    const createAff = async () => {
      const {
        createDistributor: { account },
      } = await mutations.createAffiliate({
        account: { username: username },
        govId1: '',
        affiliate: false,
        verticalId: graphqlVerticalID,
        queryParams,
      })

      if (account) {
        actions.updatedAccount(account)
      }
    }

    if (accType === 'C' && username && username !== '') {
      createAff()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accType, graphqlVerticalID, username, mutations, actions])
}

export default useConvertToRep
